import { appApi } from '~/redux/api/appApiSlice';
import {
  FeatureListingPayloadType,
  FeaturedListingRulesResponseType,
} from '~/types/featureListingTypes';

export const featureListingApiSlice = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getFeaturedListingRules: builder.query<
      FeaturedListingRulesResponseType,
      { id: string | number; locale?: string }
    >({
      query: ({ id, locale }) => {
        return {
          url: `/api/v2/listing/${id}/featured-listing-rules`,
          headers: {
            'Accept-Language': locale,
          },
        };
      },
      providesTags: ['featuredListingRules'],
    }),
    featureListing: builder.mutation<
      any,
      { id: string | number; locale?: string; body: FeatureListingPayloadType }
    >({
      query: ({ id, locale, body }) => {
        return {
          url: `/api/v2/listing/${id}/featured`,
          method: 'POST',
          body,
          headers: {
            'Accept-Language': locale,
          },
        };
      },
      invalidatesTags: (_, error) => (error ? [] : ['featuredListingRules']),
    }),
  }),
});

export const { useGetFeaturedListingRulesQuery, useFeatureListingMutation } =
  featureListingApiSlice;
